import { Skeleton } from "@/components/ui/skeleton";

const AdminSkeleton = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header skeleton */}
      <header className="bg-primary py-4 px-6">
        <div className="container mx-auto flex items-center justify-between">
          <div>
            <Skeleton className="h-6 w-48 bg-primary-foreground/20" />
            <Skeleton className="h-4 w-32 mt-1 bg-primary-foreground/10" />
          </div>
          <div className="flex items-center gap-4">
            <Skeleton className="h-4 w-40 bg-primary-foreground/10" />
            <Skeleton className="h-8 w-20 bg-primary-foreground/10" />
          </div>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8">
        {/* Tab navigation skeleton */}
        <div className="flex gap-2 mb-8">
          <Skeleton className="h-10 w-32" />
          <Skeleton className="h-10 w-28" />
          <Skeleton className="h-10 w-32" />
        </div>

        {/* Content skeleton */}
        <div className="flex items-center justify-between mb-6">
          <Skeleton className="h-8 w-56" />
          <Skeleton className="h-10 w-28" />
        </div>

        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-card rounded-lg border border-border p-4 flex items-center justify-between">
              <div className="flex-1">
                <Skeleton className="h-5 w-3/4 mb-2" />
                <Skeleton className="h-4 w-1/2" />
              </div>
              <div className="flex gap-2">
                <Skeleton className="h-8 w-8" />
                <Skeleton className="h-8 w-8" />
                <Skeleton className="h-8 w-8" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminSkeleton;
